import React, { Component } from 'react';
import ReactDOM from 'react-dom';

class LelangListFinish extends Component{
  render(){
    return(
      <>
      <li>
        <a href="">
        <div className="lelang-sec-img">
          <img src="images/materi/sample-img.png" />
          <div className="red-finish">SELESAI</div>
        </div>
        <div className="lelang-sec-detail">
          <div className="lelang-sec-text">Celana Jeans Gaul Favorit Iky</div>
          <div className="lelang-sec-harga">Rp 315.000</div>
          <div className="lelang-sec-det"><span><img src="images/clock.svg" /></span><span>2 Hari 12 Jam</span></div>
          <div className="lelang-sec-det"><span><img src="images/check.png" /></span><span>2 Tawaran</span></div>
        </div>
        </a>
      </li>
      </>
    );
  }
}

export default LelangListFinish;
